<div class="sectionbar">
  <app-opfoelgning-nav></app-opfoelgning-nav>
</div>

<div class="topbar">
  <h1>Oversigt</h1>
  <div class="topbar__actions">
    @if (canTransfer) {
      <button class="btn-icon green" (click)="transfer()" matTooltip="Opret partner">
        <mat-icon svgIcon="swap"></mat-icon>
        <span>Flyt opfølgninger</span>
      </button>
    }
  </div>
</div>
<div class="dashboard page__content">
  @if (!total || total.serviceaftaleOpfoelgningerCount + total.servicordreOpfoelgningerCount == 0) {
    <div>
      <h3>Der er ingen opfølgninger</h3>
    </div>
  } @else {
    <div class="dashboard-tile-wrapper">
      <div class="dashboard-tile">
        <mat-icon svgIcon="bookmark-solid" class="icon-32"></mat-icon>
        <div class="dashboard-tile__data">
          <div class="dashboard-tile__title">Total</div>
          @if (total.serviceaftaleOpfoelgningerCount) {
            <div class="dashboard-tile__text blue">
              <span>{{ total.serviceaftaleOpfoelgningerCount }} aftale</span>
              @if (total.serviceaftaleOpfoelgningerCount != 1) {
                <span>r</span>
              }
            </div>
          }
          @if (total.servicordreOpfoelgningerCount) {
            <div class="dashboard-tile__text blue">
              <span>{{ total.servicordreOpfoelgningerCount }} ordre</span>
              @if (total.servicordreOpfoelgningerCount != 1) {
                <span>r</span>
              }
            </div>
          }
        </div>
      </div>
      @if (overskredetDeadline.serviceaftaleOpfoelgningerCount + overskredetDeadline.servicordreOpfoelgningerCount) {
        <div class="dashboard-tile">
          <mat-icon svgIcon="obs-solid" class="mat-icon--red icon-32"></mat-icon>
          <div class="dashboard-tile__data">
            <div class="dashboard-tile__title">Overskredet deadline</div>
            @if (overskredetDeadline.serviceaftaleOpfoelgningerCount) {
              <div class="dashboard-tile__text blue">
                <span>{{ overskredetDeadline.serviceaftaleOpfoelgningerCount }} aftale</span>
                @if (overskredetDeadline.serviceaftaleOpfoelgningerCount != 1) {
                  <span>r</span>
                }
              </div>
            }
            @if (overskredetDeadline.servicordreOpfoelgningerCount) {
              <div class="dashboard-tile__text blue">
                <span>{{ overskredetDeadline.servicordreOpfoelgningerCount }} ordre</span>
                @if (overskredetDeadline.servicordreOpfoelgningerCount != 1) {
                  <span>r</span>
                }
              </div>
            }
          </div>
        </div>
      }
      <div class="dashboard-tile dashboard-tile--chart">
        <div class="dashboard-tile__title">Fordeling af prioritet</div>
        <div class="chart">
          <div class="chart__column chart__column--high">
            <div class="chart__item">
              <div class="chart__value">{{ prioritet_high }}%</div>
              <div class="chart__bar" [style.height.%]="prioritet_high"></div>
            </div>
            <div class="chart__item-text">Høj</div>
          </div>
          <div class="chart__column chart__column--medium">
            <div class="chart__item">
              <div class="chart__value">{{ prioritet_medium }}%</div>
              <div class="chart__bar" [style.height.%]="prioritet_medium"></div>
            </div>
            <div class="chart__item-text">Middel</div>
          </div>
          <div class="chart__column chart__column--low">
            <div class="chart__item">
              <div class="chart__value">{{ prioritet_low }}%</div>
              <div class="chart__bar" [style.height.%]="prioritet_low"></div>
            </div>
            <div class="chart__item-text">Lav</div>
          </div>
        </div>
      </div>
      @if (brugere) {
        <div class="dashboard-tile dashboard-tile--users">
          <div class="dashboard-tile__title">Mere end 5 opfølgninger</div>
          <div class="label-counter">
            @for (bruger of brugere; track bruger) {
              <div class="label-counter__item">
                <span>{{ bruger.user }}</span>
                <div class="label-counter__count">
                  {{ bruger.count }}
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="dashboard-tile-wrapper">
      @if (parkeret) {
        <div class="dashboard-tile">
          <mat-icon class="mat-icon--parking icon-32">local_parking</mat-icon>
          <div class="dashboard-tile__data">
            <div class="dashboard-tile__title">Parkeret</div>
            <div class="dashboard-tile__text blue">
              <span>{{ parkeret.parkeret }} ordre</span>
              @if (parkeret.parkeret != 1) {
                <span>r</span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
